module.exports = __webpack_public_path__ + "assets/img/7fd0f6e67b1a57bed568a3ba3e0dbeb1.png";